import { createAction } from '@ngrx/store';

export const BannerDownloadAppActionTypes = {
    OPEN_DOWNLOAD_APP_LINK: '[BannersSystem-download-app] OPEN_DOWNLOAD_APP_LINK',

};

export const OpenDownloadAppLink = createAction(
    BannerDownloadAppActionTypes.OPEN_DOWNLOAD_APP_LINK,
);
